export default [
      {
          path: '/coming-soon',
          name: 'misc-coming-soon',
          component: () => import('@/views/utils/ComingSoon.vue'),
          meta: {
              layout: 'full',
              resource: 'Auth',
              action: 'read',
          },
      },
      {
        path: 'not-authorized',
        name: 'misc-not-authorized',
        component: () => import('@/views/utils/NotAuthorized.vue'),
        meta: {
            layout: 'full',
            resource: 'auth',
            action: 'read',
        },
      },
      {
        path: '/under-maintenance',
        name: 'misc-under-maintenance',
        component: () => import('@/views/utils/UnderMaintenance.vue'),
        meta: {
            layout: 'full',
            resource: 'auth',
            action: 'read',
        },
      },
      {
        path: '/error',
        name: 'misc-error',
        component: () => import('@/views/utils/Error.vue'),
        meta: {
            layout: 'full',
            resource: 'auth',
            action: 'read',
        },
      },
      {
        path: '/error-404',
        name: 'error-404',
        component: () => import('@/views/utils/Error404.vue'),
        meta: {
            layout: 'full',
            resource: 'auth',
            action: 'read',
        },
      },


    {
        path: 'no-permission',
        name: 'misc-no-permission',
        component: () => import('@/views/utils/NoPermission.vue'),
        meta: {
            resource: 'common',
            action: 'read',
        },
      },
]
